import React, { useEffect, useState } from "react";
import {
    THEME_CHANGE_EVENT,
    getThemeMode,
    getThemeModeSync,
    resolveTheme,
    setThemeMode,
} from "../utils/theme";

export default function ThemeSelector({ compact = false }) {
    const [mode, setMode] = useState(() => getThemeModeSync());
    const systemEnabled = mode === "system";
    const resolved = resolveTheme(mode);
    const switchOn = resolved === "dark";

    useEffect(() => {
        let cancelled = false;
        getThemeMode().then((value) => {
            if (!cancelled) setMode(value);
        });

        const onChanged = (event) => {
            const next = event?.detail?.mode;
            if (next) setMode(next);
        };

        window.addEventListener(THEME_CHANGE_EVENT, onChanged);
        return () => {
            cancelled = true;
            window.removeEventListener(THEME_CHANGE_EVENT, onChanged);
        };
    }, []);

    const applyMode = async (value) => {
        setMode(value);
        await setThemeMode(value);
    };

    const handleSwitch = async () => {
        // Clicking the switch always sets an explicit theme (and leaves "system" mode).
        await applyMode(switchOn ? "light" : "dark");
    };

    const handleSystemToggle = async (checked) => {
        if (checked) {
            await applyMode("system");
            return;
        }
        await applyMode(resolveTheme("system"));
    };

    return (
        <div className={`theme-selector ${compact ? "theme-selector--compact" : ""}`}>
            {!compact ? (
                <div className="theme-selector__copy">
                    <strong>Тема додатка</strong>
                    <p>Світла, темна або автоматично як у системі.</p>
                </div>
            ) : null}

            <div className="theme-switch-row">
                {!compact ? (
                    <span className={`theme-switch-label ${!switchOn && !systemEnabled ? "is-active" : ""}`}>Світла</span>
                ) : null}
                <button
                    type="button"
                    className={`theme-switch ${switchOn ? "is-dark" : "is-light"} ${systemEnabled ? "is-system" : ""}`}
                    onClick={handleSwitch}
                    role="switch"
                    aria-checked={switchOn}
                    aria-label="Перемикач теми"
                    title={switchOn ? "Увімкнути світлу тему" : "Увімкнути темну тему"}
                >
                    <span className="theme-switch__thumb" aria-hidden="true" />
                </button>
                {!compact ? (
                    <>
                        <span className={`theme-switch-label ${switchOn && !systemEnabled ? "is-active" : ""}`}>Темна</span>
                        <label className="theme-system-check wr-form-check">
                            <input
                                type="checkbox"
                                checked={systemEnabled}
                                onChange={(e) => handleSystemToggle(e.target.checked)}
                            />
                            <span>Як в ОС</span>
                        </label>
                    </>
                ) : null}
            </div>
        </div>
    );
}
